export const PATH_HOME_URL = '/';
export const PATH_LOGIN_URL = '/login';
export const PATH_CLAIM_URL = '/claim';
export const PRICING_MODULE = '/pricing';
export const PATH_SETTINGS_URL = '/settings';
export const CAPPING_MODULE = '/capping';
export const PLAINING_MODULE = '/plainning';
export const OUTLET_COLOUR_CODING_MODULE = '/outlet-colour-coding';
export const SALERETURN_MODULE = '/salemansalesreturns';
export const SCHEME_MODULE = '/scheme';
export const PROVISION_MODULE = '/provisions';
export const PROVISION_MODULE_CANVAS = '/provisions/canvas';
export const SCHEME_HOLDER_MODULE = '/scheme/schemeholders/approve';
export const SCHEME_SEQUENCE_RULES = '/scheme/addapprovalsequence';
export const SKUNIT_MASTERS_PROPERTIES_MODULE = '/properties';
export const INVENTORY_MODULE = '/inventories';
export const WAREHOUSE_MODULE = '/warehouse';
export const ASSETS_MODULE = '/assets';
export const PATH_INVENTORY_TYPES_URL = '/inventorytypes';
export const PATH_INVENTORY_APPROVALS_URL = '/inventoryapprovals/index';
export const COLLECTION_MODULE = '/collection';
export const HIERARCHYWISE_SR_MODULE = '/hierarchywiseschrev';
